<template>
  <div id="upgrade-modal-container" class="custom-modal">
    <div class="modal-body">
      <div class="wrapper">
        <div class="left">
          <h3>{{ $t("components.dashboard.content.cantAccess") }}</h3>
          <p>{{ $t("components.dashboard.content.cantAccessMsg") }}</p>
        </div>
        <div class="right">
          <lottie-player v-if="!onlyButton" autoplay loop mode="normal" src="https://assets9.lottiefiles.com/private_files/lf30_atznrcwb.json" style="width: 300px;margin-bottom:2rem"></lottie-player>
        </div>
      </div>
    </div>
    <div class="modal-footer" slot="footer">
      <div class="left-buttons">
        <el-button @click="$emit('closeDialog')" type="primary">{{ $t("contentManagement.files.fileAddUpdate.close") }}</el-button>
      </div>
      <div class="right-buttons">
        <el-button @click="goOrganisation" class="fas fa-rocket">{{ $t("components.dashboard.content.upgrade") }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    organisationID:{
      type:String,
      default:null
    }
  },
  computed: {
    event() {
      return this.$store.getters.currentEvent;
    }
  },
  methods: {
    goOrganisation() {
      var path = `/organisation/${this.event.organizationID}/billing`;
      window.open(path, "_self");
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/upgrade/UpgradeDialog.vue